import {
  isNcrmActivityOpenStatus,
  normalizeNcrmActivityList,
} from "./ncrmActivity.mjs";

const toText = (value) => String(value ?? "").trim();

const parseDateToMs = (value) => {
  const normalized = toText(value);
  if (!normalized) return null;
  let parsed = new Date(normalized);
  if (Number.isNaN(parsed.getTime()) && normalized.includes(" ")) {
    parsed = new Date(normalized.replace(" ", "T"));
  }
  if (Number.isNaN(parsed.getTime())) return null;
  return parsed.getTime();
};

const resolveNcrmActivitySortDateMs = (activity) => {
  return (
    parseDateToMs(activity?.due_at)
    ?? parseDateToMs(activity?.happened_at)
    ?? parseDateToMs(activity?.created_at)
  );
};

export const sortNcrmActivityTimelineItems = (value, options = {}) => {
  const activities = normalizeNcrmActivityList(value);
  const nowCandidate = Number(options?.now);
  const nowMs = Number.isFinite(nowCandidate) ? nowCandidate : Date.now();

  const enriched = activities.map((activity, index) => {
    const dueAtMs = parseDateToMs(activity?.due_at);
    const isOpen = isNcrmActivityOpenStatus(activity?.activity_type, activity?.status);
    return {
      activity,
      index,
      isOpen,
      dueAtMs,
      isOverdue: Boolean(isOpen && dueAtMs !== null && dueAtMs < nowMs),
      sortDateMs: resolveNcrmActivitySortDateMs(activity),
    };
  });

  enriched.sort((left, right) => {
    if (left.isOpen !== right.isOpen) return left.isOpen ? -1 : 1;

    if (left.isOpen && right.isOpen) {
      if (left.isOverdue !== right.isOverdue) return left.isOverdue ? -1 : 1;

      if (left.dueAtMs !== null || right.dueAtMs !== null) {
        if (left.dueAtMs === null) return 1;
        if (right.dueAtMs === null) return -1;
        if (left.dueAtMs !== right.dueAtMs) return left.dueAtMs - right.dueAtMs;
      }
    }

    if (left.sortDateMs !== null || right.sortDateMs !== null) {
      if (left.sortDateMs === null) return 1;
      if (right.sortDateMs === null) return -1;
      if (left.sortDateMs !== right.sortDateMs) return right.sortDateMs - left.sortDateMs;
    }

    return left.index - right.index;
  });

  return enriched.map(({ activity }) => activity);
};

export const computeNcrmActivityHeaderMetrics = (value, now = Date.now()) => {
  const activities = normalizeNcrmActivityList(value);
  void now;
  const firstActivity = activities[0] || null;

  const lastActivityAt =
    toText(firstActivity?.due_at) || toText(firstActivity?.happened_at) || toText(firstActivity?.created_at) || "";

  const openTasks = activities.reduce((acc, activity) => {
    const dueAtMs = parseDateToMs(activity?.due_at);
    if (dueAtMs === null) return acc;
    if (!isNcrmActivityOpenStatus(activity?.activity_type, activity?.status)) return acc;
    return acc + 1;
  }, 0);

  return {
    lastActivityAt,
    openTasks,
  };
};
